import React from "react"
import {CTA} from "@next/cta"
import {CTAWrapper} from "./components"
import {ButtonContainer} from "../../components"
import FadeInAnimation from "../../../fadeInAnimation"
import CollaspedFilter from "../../../collaspedFilter"
import CollaspedPriceFilter from "../../../collaspedPriceFilter"
import {capitalizeFirstLetterOfEachWord} from "../../../../utils/capitalizeFirstLetter"

interface DefaultOpenFilterButtonProps {
    isFilterSelected?: boolean
    handleOpenFilterBtnClick: () => void
    isFilteredPrice: boolean
    filteredFacets: {[key: string]: string[]}
    text: string
    top: number
    $height: number
}
const DefaultOpenFilterButton = ({
    top,
    $height,
    handleOpenFilterBtnClick,
    text,
    filteredFacets,
    isFilterSelected,
    isFilteredPrice,
}: DefaultOpenFilterButtonProps) => {
    return (
        <FadeInAnimation timeout={300} show>
            <ButtonContainer
                onClick={handleOpenFilterBtnClick}
                data-testid="plp-facets-collapsed-container"
                top={top}
                $height={$height}
            >
                <CTAWrapper data-testid="plp-facets-open-filters-btn">
                    <CTA
                        themeType="Secondary"
                        rel="nofollow"
                        onClick={handleOpenFilterBtnClick}
                        enable
                        text={capitalizeFirstLetterOfEachWord(text)}
                    />
                </CTAWrapper>
                {isFilterSelected && <CollaspedFilter filteredFacets={filteredFacets} />}
                {isFilteredPrice && <CollaspedPriceFilter />}
            </ButtonContainer>
        </FadeInAnimation>
    )
}

export default DefaultOpenFilterButton
